var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3214",
    "data-name": "Rectangle 3214",
    width: 60.98,
    height: 60.995,
    fill: "#55b864"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Services_-_AI_Icon",
    "data-name": "Services - AI Icon",
    transform: "translate(-1688 -924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    transform: "translate(1688 924)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6015",
    "data-name": "Group 6015",
    transform: "translate(1709 945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6016",
    "data-name": "Group 6016",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M3.209,84.935c-.149-.049-.3-.1-.447-.147A3.835,3.835,0,0,1,0,81.22C0,81.081,0,80.941,0,80.8Q0,57.6,0,34.4A3.8,3.8,0,0,1,2.79,30.448a5.249,5.249,0,0,1,1.352-.161q13.936-.014,27.872,0a2.948,2.948,0,0,1,.765.083,1.242,1.242,0,0,1-.011,2.39,3.652,3.652,0,0,1-.884.082q-13.757.006-27.515,0c-1.475,0-1.827.35-1.827,1.821q0,22.963,0,45.926c0,1.418.392,1.814,1.794,1.814H46.5c1.386,0,1.78-.388,1.78-1.761q0-10.9,0-21.8a4.92,4.92,0,0,1,.047-.83,1.242,1.242,0,0,1,2.414-.146,3.339,3.339,0,0,1,.089.881q.007,10.752,0,21.5c0,2.751-.671,3.734-3.2,4.685Z",
    transform: "translate(0 -23.94)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M233.632,86.844a1.813,1.813,0,0,1-1.2,1.059c-1.066.37-2.114.8-3.183,1.159a1.067,1.067,0,0,0-.752.736c-.378,1.106-.8,2.2-1.2,3.294-.278.746-.719,1.124-1.313,1.1a1.374,1.374,0,0,1-1.27-1.074c-.391-1.1-.816-2.192-1.2-3.295a1.067,1.067,0,0,0-.737-.752c-1.109-.369-2.2-.8-3.292-1.208-.771-.287-1.1-.685-1.1-1.305s.33-.99,1.122-1.284c1.1-.408,2.188-.825,3.292-1.21a1.04,1.04,0,0,0,.7-.715c.387-1.124.808-2.236,1.223-3.35.272-.73.665-1.041,1.285-1.035s1,.311,1.273,1.053c.409,1.095.836,2.185,1.2,3.294a1.12,1.12,0,0,0,.791.777c1.048.361,2.077.781,3.127,1.137a1.906,1.906,0,0,1,1.228,1.028Zm-5.031-.287a2.984,2.984,0,0,1-2.611-2.582,3.011,3.011,0,0,1-2.586,2.6,2.973,2.973,0,0,1,2.6,2.568,3.011,3.011,0,0,1,2.6-2.589",
    transform: "translate(-172.652 -62.425)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M69.814,98.434c0-4.348.016-8.7-.01-13.043a3.222,3.222,0,0,1,1.665-3.126,3.307,3.307,0,0,1,3.593.3Q84.8,88.875,94.542,95.176c2.6,1.686,2.618,4.737.022,6.421q-9.759,6.33-19.532,12.64a3.325,3.325,0,0,1-3.995.01A3.188,3.188,0,0,1,69.81,111.6c.011-4.387,0-8.775,0-13.162m2.526,0c0,4.309-.008,8.617.016,12.926a1.165,1.165,0,0,0,.365.9,1.188,1.188,0,0,0,.959-.185q9.784-6.3,19.543-12.63c.985-.638.977-1.458-.016-2.1q-9.74-6.308-19.493-12.6a1.243,1.243,0,0,0-1.01-.2c-.228.126-.347.625-.349.962-.022,4.308-.015,8.617-.015,12.926",
    transform: "translate(-55.187 -64.721)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M149.874,0a1.332,1.332,0,0,1,1.283,1.048c.923,2.489,1.849,4.976,2.75,7.472a1.161,1.161,0,0,0,.78.787c2.478.892,4.945,1.815,7.414,2.73.781.289,1.11.677,1.113,1.295s-.328,1.021-1.1,1.306c-2.488.921-4.976,1.845-7.47,2.75a1.063,1.063,0,0,0-.715.7c-.9,2.5-1.829,4.983-2.75,7.472-.289.78-.681,1.115-1.291,1.119s-1.019-.335-1.3-1.1c-.922-2.489-1.847-4.977-2.752-7.471a1.06,1.06,0,0,0-.7-.713c-2.5-.9-4.981-1.83-7.47-2.752-.768-.285-1.116-.692-1.12-1.292s.351-1.02,1.108-1.3c2.488-.922,4.975-1.848,7.469-2.754a1.059,1.059,0,0,0,.711-.7c.909-2.515,1.841-5.021,2.77-7.528.267-.721.681-1.057,1.274-1.06m.027,4.982c-.123.282-.2.437-.259.6-.559,1.5-1.142,3-1.661,4.519a2.006,2.006,0,0,1-1.364,1.351c-1.517.523-3.015,1.1-4.518,1.66-.15.056-.29.139-.541.26,1.78.658,3.425,1.289,5.088,1.87a1.971,1.971,0,0,1,1.325,1.314c.524,1.516,1.1,3.014,1.663,4.518.065.175.146.345.265.625.684-1.845,1.334-3.565,1.956-5.295a1.663,1.663,0,0,1,1.084-1.085c1.493-.53,2.976-1.09,4.462-1.642.243-.09.48-.2.846-.349-1.863-.692-3.566-1.338-5.28-1.952a1.724,1.724,0,0,1-1.123-1.124c-.613-1.715-1.258-3.419-1.943-5.268",
    transform: "translate(-107.95 0)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M241.749,14.194c0,.44.014.812,0,1.183a1.291,1.291,0,0,1-1.289,1.346,1.269,1.269,0,0,1-1.255-1.313c-.022-.373,0-.748,0-1.216-.412,0-.781.012-1.148,0a1.282,1.282,0,1,1,0-2.554c.352-.014.706,0,1.149,0,0-.416-.013-.785,0-1.153a1.282,1.282,0,0,1,1.253-1.376,1.3,1.3,0,0,1,1.295,1.4c.011.352,0,.7,0,1.129.425,0,.8-.014,1.165,0a1.278,1.278,0,1,1,.005,2.552c-.37.017-.741,0-1.172,0",
    transform: "translate(-187.102 -7.2)",
    fill: "#55b864"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.30adbc08ca70ed7c4ef24bf2a89d1928.svg";
export { ForwardRef as ReactComponent };